import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faSpinner, faThumbsUp, faCheckCircle, faStar, faRefresh,
    faLock, faHeart, faHeartBroken, faAngleLeft, faAngleRight,
    faAngleDown,
    faExpand,
    faXmark,
    faPlay,
    faCircleCheck,
    faCircleXmark,
    faClockRotateLeft,
    faShareFromSquare,
    faRocket,
    faExclamationCircle,
    faPenSquare,
    faTrashAlt,
    faEye,
    faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
library.add(faSpinner, faThumbsUp, faStar, faLock, faHeart,
    faRefresh, faHeartBroken, faAngleLeft, faAngleRight, faAngleDown, faExpand, faXmark, faPlay, faCircleCheck, faCircleXmark,
    faShareFromSquare, faClockRotateLeft, faRocket, faExclamationCircle, faPenSquare, faTrashAlt, faEye, faPaperPlane);
interface IIcon {
    color?: string,
    size?: SizeProp
}


export function FASpinner(props: IIcon) {
    return (<div className='w-100 d-flex align-items-center justify-content-center' style={{ height: '100%' }}><FontAwesomeIcon icon={faSpinner as IconProp} spin={true} size="xl" color={props.color ? props.color : 'var(--secondary-purple)'} /></div>)
}

export function FAThumbsUp(props: IIcon) {
    return (<FontAwesomeIcon icon={faThumbsUp as IconProp} size="lg" color={props.color ? props.color : 'var(--secondary-green)'} />)
}

export function FAThumbsUpCircle(props: IIcon) {
    return (<FontAwesomeIcon icon={faThumbsUp as IconProp} size="lg" style={{ border: '1px solid #14CB12', borderRadius: '25px', backgroundColor: '#14CB12', padding: '5px 5px 5px 7px', transform: 'rotateY(180deg)' }} color={props.color ? props.color : 'white'} />)
}

export function FATickMark(props: IIcon) {
    return (<FontAwesomeIcon icon={faCheckCircle as IconProp} size="lg" color={props.color ? props.color : '#14CB12'} />)
}

export function FAStar(props: IIcon) {
    return (<FontAwesomeIcon icon={faStar as IconProp} size="lg" color={props.color ? props.color : 'grey'} />)
}

export function FALock(props: IIcon) {
    return (<FontAwesomeIcon icon={faLock as IconProp} size="lg" color={props.color ? props.color : 'grey'} />)
}

export function FAHeart(props: IIcon) {
    return (<FontAwesomeIcon icon={faHeart as IconProp} size="lg" color={props.color ? props.color : 'grey'} />)
}

export function FAHeartBroken(props: IIcon) {
    return (<FontAwesomeIcon icon={faHeartBroken as IconProp} size="lg" color={props.color ? props.color : 'grey'} />)
}

export function FARefresh(props: IIcon) {
    return (<FontAwesomeIcon icon={faRefresh as IconProp} size={props.size ? props.size : "lg"} color={props.color ? props.color : 'grey'} />)
}

export function FAAngleLeft(props: IIcon) {
    return (<FontAwesomeIcon icon={faAngleLeft as IconProp} size={props.size ? props.size : "sm"} color={props.color ? props.color : 'grey'} />)
}

export function FAAngleRight(props: IIcon) {
    return (<FontAwesomeIcon icon={faAngleRight as IconProp} size={props.size ? props.size : "sm"} color={props.color ? props.color : 'grey'} />)
}

/** Handing something in - the quiz's Submit. */
export function FAPaperPlane(props: IIcon) {
    return (<FontAwesomeIcon icon={faPaperPlane as IconProp} size={props.size ? props.size : "sm"} color={props.color ? props.color : 'grey'} />)
}

export function FAAngleDown(props: IIcon) {
    return (<FontAwesomeIcon icon={faAngleDown as IconProp} size={props.size ? props.size : "sm"} color={props.color ? props.color : 'grey'} />)
}

export function FAExpand(props: IIcon) {
    return (<FontAwesomeIcon icon={faExpand as IconProp} size={props.size ? props.size : "lg"} color={props.color ? props.color : 'grey'} />)
}

export function FAClose(props: IIcon) {
    return (<FontAwesomeIcon icon={faXmark as IconProp} size={props.size ? props.size : "lg"} color={props.color ? props.color : 'grey'} />)
}

export function FACheck(props: IIcon) {
    return (<FontAwesomeIcon icon={faCircleCheck as IconProp} size={props.size ? props.size : "lg"} color={props.color ? props.color : 'grey'} />)
}

export function FAIncorrect(props: IIcon) {
    return (<FontAwesomeIcon icon={faCircleXmark as IconProp} size={props.size ? props.size : "lg"} color={props.color ? props.color : 'grey'} />)
}

export function FAShare(props: IIcon) {
    return (<FontAwesomeIcon icon={faShareFromSquare as IconProp} size={props.size ? props.size : "lg"} color={props.color ? props.color : 'grey'} />)
}

export function FAClockRotateLeft(props: IIcon) { 
    return (<FontAwesomeIcon icon={faClockRotateLeft as IconProp} size={props.size ? props.size : "lg"} color={props.color ? props.color : 'grey'} />)
}

export function FARocket(props: IIcon) {
    return (<FontAwesomeIcon icon={faRocket as IconProp} size={props.size ? props.size : "lg"} color={props.color ? props.color : 'grey'} />)
}

export function FAExclamationCircle(props: IIcon) {
    return (<FontAwesomeIcon icon={faExclamationCircle as IconProp} size={props.size ? props.size : "lg"} color={props.color ? props.color : 'grey'} />)
}

export function FAPenSquare(props: IIcon) {
    return (<FontAwesomeIcon icon={faPenSquare as IconProp} size={props.size ? props.size : "lg"} color={props.color ? props.color : 'grey'} />)
}

export function FADelete(props: IIcon) {
    return (<FontAwesomeIcon icon={faTrashAlt as IconProp} size={props.size ? props.size : "lg"} color={props.color ? props.color : 'grey'} />)
}

export function FAEye(props: IIcon) {
    return (<FontAwesomeIcon icon={'eye' as IconProp} color={props.color} size={props.size} />)
}
